import Vue from 'vue';

export const apiService = {
  methods: {
    storeData(data) {
      return Vue.http.post(
        `${process.env.BACKEND_API_URL}api/v2/kiosks/${data.kiosk}/permit-types`,
        {
          name: data.name,
          description: data.description,
          pricing_rule: data.pricing_rule,
          availability: data.availability,
          icon: data.icon,
          mode: data.mode
        })
        .then((response) => {
          return response
        })
        .catch((response) => {
          return response
        });
    },
    getList(kiosk) {
      return Vue.http.get(
        `${process.env.BACKEND_API_URL}api/v2/kiosks/${kiosk}/permit-types`)
        .then((response) => {
          return response.body
        })
        .catch((response) => {
          return response
        });
    },
    deleteItem(id, kiosk) {
      return Vue.http.delete(
        `${process.env.BACKEND_API_URL}api/v2/kiosks/${kiosk}/permit-types/${id}`)
        .then((response) => {
          return response.body
        })
        .catch((response) => {
          return response
        });
    },
    updateItem(data) {
      return Vue.http.put(
        `${process.env.BACKEND_API_URL}api/v2/kiosks/${data.kiosk}/permit-types/${data.id}`,
        {
          name: data.name,
          description: data.description,
          pricing_rule: data.pricing_rule,
          availability: data.availability,
          id_code_enabled: data.id_code_enabled,
          icon: data.icon,
          mode: data.mode
        })
        .then((response) => {
          return response
        })
        .catch((response) => {
          return response
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tenants/ticket-types/api/services.js